import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-[32px]',
    title: 'heading-2xl lg:heading-3xl leading-[120%] font-semibold',
    fields: 'flex flex-col gap-6 pb-10',
    row: 'flex items-center justify-between',
    button: 'w-full',
    alreadyHaveAccount: 'mt-3 cursor-pointer px-0 py-3',
    backButton: '[&>span>span]:text-regular! h-auto! p-0!'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
